import { useEffect, useState } from "react";
import { Fab, Tooltip } from "@mui/material";
import Iconify from "src/components/iconify";
import useService from "src/hooks/useService";
import AssistantTestChatModal from "src/sections/@dashboard/assistant-test-chat/AssistantTestChatModal";

// ----------------------------------------------------------------------

// Botão flutuante disponível em todo o dashboard (fora das telas de
// configurar assistente) pra abrir o chat de teste rapidamente, sem
// precisar navegar até "Configurar assistente". Só aparece quando o
// owner já tem um assistente configurado (mesma checagem que a tela de
// configuração já fazia pro botão antigo "Testar assistente").
export default function AssistantTestChatFab() {
  const [open, setOpen] = useState(false);

  const { data: dataAssistantConfigured, refetch: triggerAssistantConfigured } = useService(
    "/assistant-config/assistant-configured",
    { manual: true }
  );

  useEffect(() => {
    triggerAssistantConfigured();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasAssistant = Boolean(dataAssistantConfigured?.hasAssistant);

  // O layout do dashboard nunca desmonta durante a navegação, então uma
  // única checagem no mount trava o valor de hasAssistant para sempre. Faz
  // polling só enquanto ainda não há assistente configurado (ex: owner
  // recém-cadastrado terminando o wizard pela 1ª vez); para assim que
  // hasAssistant vira true, já que não volta a ficar false na sessão.
  // useService.refreshOnFocus não serve aqui: o próprio hook o desativa
  // quando `manual: true`, então o refetch em foco é feito à mão.
  useEffect(() => {
    if (hasAssistant) return undefined;

    const intervalId = setInterval(() => {
      triggerAssistantConfigured();
    }, 5000);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        triggerAssistantConfigured();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAssistant]);

  if (!hasAssistant) return null;

  return (
    <>
      <Tooltip title="Testar assistente" placement="left">
        <Fab
          color="primary"
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.speedDial,
          }}
        >
          <Iconify icon="solar:chat-round-dots-linear" width={28} />
        </Fab>
      </Tooltip>

      <AssistantTestChatModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
